import { useEffect, useState } from 'react';
import api from '../../services/api';
import AdminLayout from '../../layouts/AdminLayout';
import Button from '../../components/common/Button';
import SecuritySection from '../../components/common/SecuritySection';
import toast from 'react-hot-toast';

export default function AdminSettings() {
  const [settings, setSettings] = useState([]);
  const [editing, setEditing] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    api.get('/admin/settings').then((r) => {
      setSettings(r.data.data);
      setLoading(false);
    });
  }, []);

  async function saveSetting(key, value) {
    setSaving(key);
    try {
      await api.put(`/admin/settings/${key}`, { value });
      setSettings((prev) => prev.map((s) => s.setting_key === key ? { ...s, setting_value: value } : s));
      setEditing((prev) => { const n = { ...prev }; delete n[key]; return n; });
      toast.success('Setting updated');
    } finally { setSaving(null); }
  }

  if (loading) return <AdminLayout><div className="animate-pulse p-8">Loading settings...</div></AdminLayout>;

  return (
    <AdminLayout>
      <div className="space-y-5">
        <h1 className="text-xl font-bold text-gray-900">System Settings</h1>

        <SecuritySection readOnlyEmail />
        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
          {settings.map((s) => (
            <div key={s.setting_key} className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-900 text-sm">{s.setting_key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</p>
                {s.description && <p className="text-xs text-gray-500 mt-0.5">{s.description}</p>}
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {editing[s.setting_key] !== undefined ? (
                  <>
                    <input
                      className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm w-28 focus:ring-2 focus:ring-brand-500 focus:outline-none"
                      value={editing[s.setting_key]}
                      onChange={(e) => setEditing((p) => ({ ...p, [s.setting_key]: e.target.value }))}
                    />
                    <Button size="sm" loading={saving === s.setting_key} onClick={() => saveSetting(s.setting_key, editing[s.setting_key])}>Save</Button>
                    <Button size="sm" variant="secondary" onClick={() => setEditing((p) => { const n = { ...p }; delete n[s.setting_key]; return n; })}>Cancel</Button>
                  </>
                ) : (
                  <>
                    <span className="text-sm font-mono bg-gray-100 px-3 py-1.5 rounded-lg text-gray-800 truncate max-w-[8rem]">{s.setting_value}</span>
                    <Button size="sm" variant="secondary" onClick={() => setEditing((p) => ({ ...p, [s.setting_key]: s.setting_value }))}>Edit</Button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
